import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useNotifications } from '@/hooks/useNotifications';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export function NotificationsButton() {
  const { user } = useCurrentUser();
  const { unreadCount } = useNotifications(500);

  // Ensure unreadCount is a number
  const count = typeof unreadCount === 'number' ? unreadCount : 0;

  if (!user) {
    return null;
  }

  return (
    <Link to="/notifications">
      <Button
        variant="secondary"
        size="icon"
        className="h-9 w-9 relative"
      >
        <Bell className="h-5 w-5" />
        {count > 0 && (
          <div className="absolute top-0.5 right-0.5 h-2.5 w-2.5 bg-red-500 rounded-full" />
        )}
      </Button>
    </Link>
  );
}
